import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import logo from "@/assets/sd-logo-transparent.webp";

type Props = {
  title?: string;
  text?: string;
  ctaLabel?: string;
  ctaTo?: string;
};

export const CtaBanner = ({
  title = "Gratis Erstbesichtigung",
  text = "Wir kommen vorbei, schauen uns alles an und erstellen Ihnen ein völlig unverbindliches Angebot — kostenlos & ohne Verpflichtung.",
  ctaLabel = "Jetzt anfragen",
  ctaTo = "/kontakt",
}: Props) => {
  return (
    <section className="relative overflow-hidden bg-hero-gradient">
      <div className="container-narrow relative py-16 md:py-20">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center"
        >
          <div className="flex items-center gap-6">
            <img
              src={logo}
              alt="S&D Facility Service"
              loading="lazy"
              className="hidden h-24 w-auto shrink-0 drop-shadow-xl sm:block md:h-28"
            />
            <div className="max-w-xl">
              <h2
                className="text-white"
                style={{ fontSize: 32, fontWeight: 700, lineHeight: 1.2 }}
              >
                {title}
              </h2>
              <p
                className="mt-3 body-base"
                style={{ color: "rgba(255,255,255,0.85)" }}
              >
                {text}
              </p>
            </div>
          </div>

          <Link
            to={ctaTo}
            className="inline-flex shrink-0 items-center justify-center rounded-lg bg-accent px-7 py-3.5 text-[15px] font-semibold text-primary transition-transform hover:scale-[1.02]"
            style={{ letterSpacing: "0.3px" }}
          >
            {ctaLabel}
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
